import React, {useState} from "react";
import { Dropdown } from "antd";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ProfileMenu } from "../../../navigation";
import { TextInput } from "../../../components";
import { VscHome, VscBell } from "react-icons/vsc";
import { RiVideoFill } from "react-icons/ri";
import { IoFootballOutline, IoSearchOutline } from "react-icons/io5";
import { RiCloseCircleFill } from "react-icons/ri";
import { BsBarChart, BsPeople } from "react-icons/bs";
import { GoComment } from "react-icons/go";
import Profile from "../../../assets/profile-image.png";
import Logo from "../../../assets/SC.png";
import { SideBar } from "../../../navigation";
import {Animated} from "react-animated-css";
import { MdOutlineArrowDropDown } from "react-icons/md";

const Header = () => {
  const location = useLocation(); 
  const {pathname} = location;
  const { isDarkMode } = useSelector(({ common }) => common);

  const [showSearchInput, setShowSearchInput] = useState(false);
  
  return (
    <>
      <div className="display flex flex-row mx-auto px-4 lg:px-12 pt-4 justify-between bg-white header">
        <div className="flex items-center">
          <div className="block lg:hidden">
            <SideBar />
          </div>
          <div className={`${showSearchInput ? "hidden md:block" : ""} pb-4`}>
            <div className={`${!isDarkMode ? "block" : "hidden"}`}>
              <img src={Logo} />
            </div>
            <div className={`${isDarkMode ? "block" : "hidden"}`}>
              <h4 className="font-bold text-2xl header-dark">SportsCliq</h4>
            </div>
            
          </div>
        </div>
        <div className={`${!showSearchInput ? "flex" : "hidden"} justify-between items-center w-1/3 navigation`}>
          <div className={`${pathname === "/home" ? "headerIconsActive" : ""} menu-icon flex flex-col items-center h-full`}>
            <Link to="/home"><VscHome  className="headerIcons" /></Link>
            <p className="block xl:hidden">Feeds</p>
          </div>
          <div className={`${pathname === "/watch" ? "headerIconsActive" : ""} menu-icon flex flex-col items-center h-full`}>
            <Link to="/watch"><RiVideoFill className="headerIcons" /></Link>
            <p className="block xl:hidden">Watch</p>
          </div>
          <div className={`${pathname === "/livescores" ? "headerIconsActive" : ""} menu-icon flex flex-col items-center h-full`}>
            <Link to="/livescores"><IoFootballOutline className="headerIcons" /></Link>
            <p className="block xl:hidden">Scores</p>
          </div>
          <div className={`${pathname === "/standings" ? "headerIconsActive" : ""} menu-icon flex flex-col items-center h-full`}>
            <Link to="/standings"><BsBarChart className="headerIcons" /></Link>
            <p  className="block xl:hidden">Stats</p>
          </div>
          <div className={`${pathname === "/forums" ? "headerIconsActive" : ""} menu-icon flex flex-col items-center h-full`}>
            <Link to="/forums"><BsPeople className="headerIcons" /></Link>
            <p className="block xl:hidden">Games</p>
          </div>
        </div>
        {/* search bar */}
        <div className={`${showSearchInput ? "block" : "hidden"} w-1/2 pb-4`}>
          <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={showSearchInput}>
            <TextInput
              placeholder="Search SportCliqs"
              type="text"
              size="middle"
              name="search"
              className="search-input"
              suffix={<RiCloseCircleFill onClick={() => setShowSearchInput(!showSearchInput)} />}
              icon={<IoSearchOutline />}
            />
          </Animated>
        </div>

        <div className="flex justify-around items-center w-5/12 sm:w-3/12 lg:w-2/12 pb-4">
          <div className="block">
            <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={!showSearchInput}>
              <IoSearchOutline  className={`${showSearchInput ? "hidden" : "block"} headerIcons`} onClick={() => setShowSearchInput(!showSearchInput)} />
            </Animated>
          </div>
          <div className="flex justify-around w-3/5 items-center">
            <div>
              <VscBell className="headerIcons" />
            </div>
            <div className="hidden lg:block profileMenu">
              <Dropdown overlay={ProfileMenu} placement="bottomRight" arrow>
                <div className="flex items-center">
                  <img src={Profile} className="profileImg" />
                  <MdOutlineArrowDropDown />
                </div>
              </Dropdown>
            </div>
            <div className="block lg:hidden">
              <GoComment className="headerIcons" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
